import { Injectable } from '@angular/core';
import { ApiService, AppSettingsService } from '@woolworthsnz/styleguide';
import { MealPlan as MealPlanResponse } from '@woolworthsnz/trader-api';
import { map, Observable } from 'rxjs';
import { mapToRecipeStampLocal } from '../helpers';
import { MealPlan } from '../models';

const latestMealPlanFulfilmentMaxDaysAgo = 14;

@Injectable({ providedIn: 'root' })
export class MyMealPlansService {
	constructor(private apiService: ApiService, private appSettingsService: AppSettingsService) {}

	public fetchLatestMealPlan(maxDaysAgo = latestMealPlanFulfilmentMaxDaysAgo): Observable<MealPlan | undefined> {
		return this.fetchPastMealPlansSorted(maxDaysAgo).pipe(map((mealPlanList) => mealPlanList[0]));
	}

	public fetchPastMealPlansSorted(fulfilmentInPastDays?: number): Observable<MealPlan[]> {
		return this.fetchPastMealPlans(fulfilmentInPastDays).pipe(
			map(this.mapToUsableMealPlan),
			map((mealPlanList) => (mealPlanList || []).sort(this.sortByMostRecentOrder))
		);
	}

	private fetchPastMealPlans(fulfilmentInPastDays?: number | undefined): Observable<MealPlanResponse[] | undefined> {
		const maxDaysAgo = fulfilmentInPastDays ? `?daysFrom=${fulfilmentInPastDays}` : '';

		return this.apiService.get(`${this.appSettingsService.getEndpoint('mealPlanPastMealPlans')}${maxDaysAgo}`);
	}

	private sortByMostRecentOrder(a: MealPlan, b: MealPlan): number {
		return b.orderId - a.orderId;
	}

	private mapToUsableMealPlan(response: MealPlanResponse[] | undefined): MealPlan[] {
		return (
			response?.map((mealPlan) => ({
				orderId: mealPlan.orderId || 0,
				fulfilmentDate: String(mealPlan.fulfilmentDate) || '',
				meals: mealPlan.meals?.map((meal) => ({ recipe: mapToRecipeStampLocal(meal) })) || [],
			})) || []
		);
	}
}
